import { useSelector } from "react-redux";

// Чаты WhatsApp видны по умолчанию. Админка может скрыть их для конкретного
// филиала инвертированным тумблером access_toggles.whatsapp_chats_hidden:
// enabled = чаты скрыты. Филиалы без тумблера (вся текущая база) видят чаты.
export const useWhatsappChatsHidden = () => {
    const toggle = useSelector(
        s => s.branchReducer?.info?.configuration?.access_toggles?.whatsapp_chats_hidden
    );

    if (!toggle?.enabled) return false;

    const now = Date.now();
    if (toggle.start_at > 0 && now < toggle.start_at) return false;
    if (toggle.expire_at > 0 && now > toggle.expire_at) return false;

    return true;
};
